import { TenantGeneralData } from './tenantGeneralData';

export class Address extends TenantGeneralData {
  county: string;
  country: string;
  countryCode?: string;
  type: string;
  street1: string;
  street2: string;
  city: string;
  zipCode: string;
  lat: number;
  lng: number;
  buildingFloor: string;
  intercom: string;

  constructor() {
    super();
    this.id = null;
    this.county = null;
    this.country = null;
    this.countryCode = null;
    this.type = null;
    this.street1 = null;
    this.street2 = null;
    this.city = null;
    this.zipCode = null;
    this.lat = null;
    this.lng = null;
    this.buildingFloor = null;
    this.intercom = null;
  }
}
